"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var mobx_react_1 = require("mobx-react");
var mui_1 = require("tss-react/mui");
// locals
var util_1 = require("../util");
var useStyles = (0, mui_1.makeStyles)()(function (theme) {
  return {
    selectPaper: {
      padding: theme.spacing(4)
    }
  };
});
var ViewLauncher = (0, mobx_react_1.observer)(function (_ref) {
  var session = _ref.session;
  var _a;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var _ref2 = (0, util_1.getEnv)(session),
    pluginManager = _ref2.pluginManager;
  var viewTypes = pluginManager.getElementTypeRecord('view').all();
  var _ref3 = (0, react_1.useState)((_a = viewTypes[0]) === null || _a === void 0 ? void 0 : _a.name),
    _ref4 = _slicedToArray(_ref3, 2),
    value = _ref4[0],
    setValue = _ref4[1];
  return react_1.default.createElement(material_1.Paper, {
    className: classes.selectPaper
  }, react_1.default.createElement(material_1.Typography, null, "Select a view to launch"), react_1.default.createElement(material_1.FormControl, {
    style: {
      margin: 2
    }
  }, react_1.default.createElement(material_1.Select, {
    value: value,
    onChange: function onChange(event) {
      return setValue(event.target.value);
    }
  }, viewTypes.map(function (_ref5) {
    var displayName = _ref5.displayName,
      name = _ref5.name;
    return react_1.default.createElement(material_1.MenuItem, {
      key: name,
      value: name
    }, displayName);
  }))), react_1.default.createElement(material_1.FormControl, {
    style: {
      margin: 2
    }
  }, react_1.default.createElement(material_1.Button, {
    onClick: function onClick() {
      return session.addView(value, {});
    },
    variant: "contained",
    color: "primary"
  }, "Launch view")));
});
exports.default = ViewLauncher;